<script setup>
import { ref, computed } from 'vue'
import { groupBy } from 'lodash-es'
import ReferenceInfo from '@/components/safety/ReferenceInfo.vue'
import StringWithMarkup from '@/components/safety/StringWithMarkup.vue'

const props = defineProps({
  section: { type: Object, required: true },
  references: { type: Array, required: true },
  titleFilter: { type: Array, required: false },
  paginated: { type: Boolean, default: false },
  showMarkup: { type: Boolean, default: false },
})

const page = ref(1)

const groups = computed(() => groupBy(props.section?.Information || [], 'ReferenceNumber'))

const nPages = computed(() => Object.keys(groups.value).length)

const groupHasTitles = (group) => {
  return !!group.find((info) => info.Name)
}

const isPaginatedChosen = ref(props.paginated)
</script>

<template>
  <div
    v-if="section.Information"
    class="d-flex flex-column"
    style="min-height: 0; gap: 0.5rem"
  >
    <div
      v-if="nPages > 1"
      class="d-flex flex-column justify-content-center"
    >
      <v-checkbox
        v-model="isPaginatedChosen"
        label="Paginated"
        hide-details
        dense
      />

      <v-pagination
        v-if="isPaginatedChosen"
        v-model="page"
        :length="nPages"
        :total-visible="7"
        dense
      />

      <!-- <v-checkbox
            v-model="paginated"
            label="Paginated"
          /> -->
    </div>

    <div class="overflow-auto">
      <div
        v-for="(group, refno, pn) in groups"
        :key="refno"
        class="mb-3"
      >
        <div v-if="!isPaginatedChosen || page - 1 === pn">
          <div
            v-for="(info, j) in group"
            :key="j"
            class="d-flex flex-row"
            style="gap: 1rem"
          >
            <template v-if="!titleFilter || titleFilter.includes(info.Name)">
              <div
                v-if="groupHasTitles(group)"
                class="w-20 text-right"
                style="text-decoration: underline dotted"
              >
                {{ info.Name }}
              </div>
              <div>
                <div
                  v-for="(swm, k) in info.Value.StringWithMarkup"
                  :key="k"
                  class="text-left"
                >
                  <StringWithMarkup
                    :swm="swm"
                    :show-markup="showMarkup"
                  />
                </div>
              </div>
            </template>
          </div>

          <div><ReferenceInfo :reference="references.find((r) => r.ReferenceNumber === refno)" /></div>
        </div>
      </div>
    </div>
  </div>
</template>
